import type { EpisodeOfCare } from "@rmh/defs";
import { BodyPartType } from "@rmh/defs";

export const getEpisodeOfCareBodyPart = (eoc: EpisodeOfCare) => {
  return eoc.incident?.affectedBodyRegion.bodyRegion;
};

export const getEpisodeOfCareBodyPartString = (eoc: EpisodeOfCare) => {
  return getEpisodeOfCareBodyPart(eoc)?.replaceAll("_", " ") ?? "";
};

export enum BodyFigureView {
  Front,
  RightSide,
  Back,
  LeftSide,
}

export const getDefaultBodyFigureView = (selectedBodyPart?: BodyPartType) => {
  if (!selectedBodyPart) {
    return BodyFigureView.Front;
  }

  return [
    BodyPartType.Buttocks,
    BodyPartType.LowerBack,
    BodyPartType.UpperBack,
    BodyPartType.LeftHip,
    BodyPartType.RightHip,
  ].includes(selectedBodyPart)
    ? BodyFigureView.Back
    : BodyFigureView.Front;
};
